module.exports = __webpack_public_path__ + "static/site-designe.d22486fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/img/site-designe.png
// module id = 815
// module chunks = 59393608157790